<template>
    <ui-container class="space-y-8 py-8">

        <!-- Header. -->
        <ui-header :title="`${item.title}`" :subtitle="item.description" :show-new-action="showNewAction" :new-action="newAction">
            <template #actions>
                <ui-button-new v-if="edit" icon="fas fa-pencil" @click="edit()">Edit</ui-button-new>
                <ui-button-new v-if="removeItem" icon="fas fa-trash" danger @click="openDeleteModal">Delete</ui-button-new>
            </template>
        </ui-header>

        <!-- Data grid. -->
        <ui-data-grid>
            <ui-data-grid-item label="Status" class="sm:col-span-full">
                <ui-button-new v-if="item.approved" success small @click="unapproveForm.submit()" :loading="unapproveForm.busy" :disabled="! canApprove">Approved</ui-button-new>
                <ui-button-new v-else danger small @click="approveForm.submit()" :loading="approveForm.busy" :disabled="! canApprove">Unapproved</ui-button-new>
            </ui-data-grid-item>
            <ui-data-grid-item label="NBS">{{ item.nbs }}</ui-data-grid-item>
            <ui-data-grid-item label="Unit of Measure">{{ item.unit_of_measure }}</ui-data-grid-item>
            
            <ui-data-grid-item label="Materials and Labour Rates" class="sm:col-span-full">
                <global-specs-form-table :form="item" read-only></global-specs-form-table>
            </ui-data-grid-item>

            <!-- <ui-data-grid-item label="Units of Measure">{{ item.unit_of_measure }}</ui-data-grid-item> -->
            <!-- <ui-data-grid-item :label="`Total Cost Per ${item.unit_of_measure}`">{{ item.cost_per_uom | toCurrency }}</ui-data-grid-item> -->
            <!-- <ui-data-grid-item :label="`Materials Cost Per ${item.unit_of_measure}`">{{ item.materials_cost_per_uom | toCurrency }}</ui-data-grid-item> -->
            <!-- <ui-data-grid-item :label="`Labour Cost Per ${item.unit_of_measure}`">{{ item.labour_cost_per_uom | toCurrency }}</ui-data-grid-item> -->
            <!-- <ui-data-grid-separator /> -->
            <!-- <global-specs-show-material-and-labour-list :materials="item.materials" :labour="item.labour" :uom="item.unit_of_measure" /> -->
            <!-- <ui-data-grid-separator /> -->

          <ui-data-grid-item label="Created By">{{ item.created_by }} on {{ item.created_at }}</ui-data-grid-item>
          <ui-data-grid-item label="Last Updated By">{{ item.updated_by }} on {{ item.updated_at }}</ui-data-grid-item>
        </ui-data-grid>

    </ui-container>
</template>

<script>
export default {
  props: {
        item: Object,
        edit: Function,
        removeItem: Function,
        showNewAction: Boolean,
        newAction: {type: Function, required: false, default: function(){}},
        canApprove: Boolean,
    },
    data () {
        return {
            approveForm: new Form({}, async () => this.item.approve()),
            unapproveForm: new Form({}, async () => this.item.unapprove()),
        }
    },
    methods: {
        openDeleteModal () {
            const title = 'Are you sure you want to remove this global spec item?'
            const description = 'You are removing the spec item "' + this.item.title + '". Are you sure you want to do this?'
            eventBus.$emit('delete-modal-open', title, description, async () => {
                await this.item.delete()
                this.removeItem(this.item)

            });
        },
    },
}
</script>
